import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { ExternalLink } from "lucide-react";

const STATUSES = [
  { v: "open", label: "Em andamento" },
  { v: "in_progress", label: "Em produção" },
  { v: "review", label: "Em revisão" },
  { v: "done", label: "Entregue" },
  { v: "cancelled", label: "Cancelada" },
];

export default function ClientDemandsView() {
  const [list, setList] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");

  const load = () => {
    const params = statusFilter ? { status: statusFilter } : {};
    api.get("/admin/client-demands", { params }).then(({ data }) => setList(data));
  };
  useEffect(() => { load(); }, [statusFilter]);

  const setStatus = async (d, s) => {
    await api.put(`/admin/client-demands/${d.id}`, { status: s });
    toast.success("Status atualizado.");
    load();
  };

  return (
    <div>
      <h1 className="font-display text-4xl mb-2">Demandas Recebidas</h1>
      <p className="text-sm text-neutral-500 mb-6">Briefings enviados pelos clientes via botão DEMANDAR. Se ClickUp estiver configurado, a tarefa é criada automaticamente.</p>

      <div className="mb-4 flex gap-2 flex-wrap">
        <button onClick={() => setStatusFilter("")} className={`text-xs px-3 py-1.5 rounded-full ${!statusFilter ? "bg-black text-white" : "border border-black/15"}`}>Todos</button>
        {STATUSES.map((s) => (
          <button key={s.v} onClick={() => setStatusFilter(s.v)} className={`text-xs px-3 py-1.5 rounded-full ${statusFilter === s.v ? "bg-black text-white" : "border border-black/15"}`}>{s.label}</button>
        ))}
      </div>

      <div className="space-y-3">
        {list.map((d) => (
          <div key={d.id} className="border border-black/10 rounded-md p-4">
            <div className="flex flex-wrap justify-between items-start gap-4">
              <div className="flex-1 min-w-[300px]">
                <div className="text-[10px] uppercase tracking-widest text-accent-orange">{d.department} · {d.work_front}</div>
                <div className="font-display text-xl">{d.piece_type}</div>
                <div className="text-xs text-neutral-500 mt-1">De: {d.client_email}</div>
                {d.objectives && <div className="text-sm mt-2">🎯 {d.objectives}</div>}
                {d.description && <div className="text-xs text-neutral-600 mt-1">{d.description}</div>}
                {d.clickup_task_url && <a href={d.clickup_task_url} target="_blank" rel="noopener noreferrer" className="text-xs text-accent-orange hover:underline inline-flex items-center gap-1 mt-2"><ExternalLink className="w-3 h-3" /> Ver no ClickUp</a>}
              </div>
              <div className="text-right">
                <select value={d.status || "open"} onChange={(e) => setStatus(d, e.target.value)} className="border border-black/15 rounded px-2 py-1 text-xs">
                  {STATUSES.map((s) => <option key={s.v} value={s.v}>{s.label}</option>)}
                </select>
                <div className="text-[10px] text-neutral-400 mt-2">{new Date(d.created_at).toLocaleString("pt-BR")}</div>
              </div>
            </div>
          </div>
        ))}
        {list.length === 0 && <div className="text-center text-sm text-neutral-500 border border-dashed border-black/15 rounded p-8">Nenhuma demanda no filtro atual.</div>}
      </div>
    </div>
  );
}
